
namespace Matrix.Workflow {

    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class WorkflowBatchAssignmentDialog extends Serenity.PropertyDialog<WorkflowMapRow, any> {
        protected getFormKey() { return WorkflowMapForm.formKey; }
        protected getLocalTextPrefix() { return WorkflowMapRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowMapRow.nameProperty; }

        protected form = new WorkflowMapForm(this.idPrefix);

        constructor() {
            super();

            this.dialogTitle = 'Batch Assignment';
        }

        protected getTemplate() {
            return Serenity.EntityDialog.prototype["getFallbackTemplate"].call(this);
        }

        protected getPropertyItems() {
            var items = super.getPropertyItems();

            items = items.filter(x => !x.hideOnInsert);
            items = Q.deepClone(items);

            var testCode = Q.tryFirst(items, x => x.name == 'TestCode');
            testCode && ((testCode.editorParams = testCode.editorParams || {}).multiple = true);
            testCode && (testCode.editorParams.maxLength = 0);
            testCode && (testCode.maxLength = 0);
            var resultCode = Q.tryFirst(items, x => x.name == 'ResultCode');
            resultCode && ((resultCode.editorParams = resultCode.editorParams || {}).multiple = true);
            resultCode && (resultCode.editorParams.maxLength = 0);
            resultCode && (resultCode.maxLength = 0);

            return items;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            return [
                {
                    title: 'Save',
                    cssClass: 'my-save-button',
                    icon: 'mdi mdi-content-save-all text-lime',
                    onClick: () => {
                        if (!this.validateForm())
                            return;
                        var request = this.propertyGrid.save();
                        WorkflowMapService.BatchAssignment(request, response => {
                            if (!response.Inserted)
                                Q.notifyWarning('Could not insert any new mappings as all pairs already exists!');
                            else if (!response.Existing) {
                                Q.notifySuccess('Inserted ' + response.Inserted + ' mappings.');
                                this.dialogClose();
                            }
                            else {
                                Q.notifySuccess('Inserted ' + response.Inserted + ' mappings, skipped ' + response.Existing + ' existing mappings.');
                                this.dialogClose();
                            }
                        });
                    }
                }
            ]
        }
    }
}